import { FormSchema } from '@/forms/types/schema';
import { mergeSchemaAndValues } from '@/forms/utils/merge-schema-and-values';
import { CreateCredentialFieldValues } from './field-values';

const baseSchema = (): FormSchema<CreateCredentialFieldValues> => ({
  username: {
    type: 'text',
    label: 'Username',
    placeholder: 'Enter username',
    value: '',
    validation: { required: true, maxLength: 100 },
  },
  password: {
    type: 'text',
    label: 'Password',
    placeholder: 'Enter password',
    value: '',
    validation: { required: true, maxLength: 100 },
  },
  type: {
    type: 'select',
    label: 'Type',
    value: 'wellbeing',
    options: [{ value: 'wellbeing', label: 'wellbeing' }],
    validation: { required: true },
  },
});

export const buildCreateCredentialFormSchema = (
  values?: CreateCredentialFieldValues,
): FormSchema<CreateCredentialFieldValues> => {
  const schema = values
    ? mergeSchemaAndValues(baseSchema(), values)
    : baseSchema();
  return schema;
};
